import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import ServiceDetailPage from "../pages/services/detail/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/services/recurring-cleaning", element: <ServiceDetailPage slug="recurring-cleaning" /> },
  { path: "/services/deep-cleaning", element: <ServiceDetailPage slug="deep-cleaning" /> },
  { path: "/services/move-in-out-cleaning", element: <ServiceDetailPage slug="move-in-out-cleaning" /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;